import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { RouterService } from '@shared/services/router.service';
import { LoaderService } from '@shared/services/loader.service';

@Component({
  selector: 'app-login-container',
  templateUrl: './login-container.component.html',
  styleUrls: ['./login-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LoginContainerComponent implements OnInit {
  loginLoading$: Observable<boolean>;
  currentPath$: Observable<any>;

  constructor(
    private loadingService: LoaderService,
    private routerService: RouterService,
  ) {}

  ngOnInit(): void {
    this.currentPath$ = this.routerService.getCurrentRoute();
    this.loginLoading$ = this.loadingService.getLoading();
  }
}
